import React, { Component } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';

import connect from '../../utils/connect';

//import css from './account.scss';

import Splitter from './block/splitter';
import ContentBlock from './block/content';
import SubmitBlock from './block/submit';

import InputText from  '../form/input/text';
import InputSubmit from  '../form/input/submit';
import InputCheckbox from  '../form/input/checkbox';
import ConfirmDialog from  '../form/confirm';

import {
	updateLogin,
	deleteLogin,
} from '../../actions/users';

import {
	formIsValid,
	VALIDATE_NOT_EMPTY,
	VALIDATE_MIN_LENGTH,
	VALIDATE_EMAIL,
	VALIDATE_CHECKED,
	VALIDATE_CUSTOM,
} from '../form/validate';

import translate from '../../utils/translate';

class AccountBasic extends Component {

	constructor(props) {
		super();

		this.state = {
			waiting: false,
		};
	}

	render() {

		this.formElements = [];
		this.formElements.push(
			<InputText
				className='span3 span11-mobile'
				ref='name'
				key='name'
				label='Name'
				name='name'
				placeholder='Full name'
				value={this.props.users.name}
				validate={[
					{rule: VALIDATE_NOT_EMPTY},
					{rule: VALIDATE_MIN_LENGTH, params: 2},
				]}
			/>,

			<InputText
				className='span3 span11-mobile'
				ref='email'
				key='email'
				label='Email'
				name='email'
				placeholder='Email'
				value={this.props.users.email}
				validate={[
					{rule: VALIDATE_EMAIL},
				]}
			/>,

			<InputCheckbox key='newsletter'name='newsletter' ref='newsletter' value={!!this.props.users.receiveNewsletter}>
				{translate('account/misc/newletter')}

			</InputCheckbox>,

			<InputText
				className='span3 span11-mobile'
				ref='oldPassword'
				key='oldPassword'
				label='Old Password'
				name='oldPassword'
				type='password'
				placeholder='Password'
				manualValidate={true}
				validate={[
					{
						rule: VALIDATE_CUSTOM,
						params: (val) => {
							if (val) {
								return (val.length >= 6);
							} else {
								return true;
							}
						},
					},
				]}
			/>,

			<InputText
				className='span3 span11-mobile'
				ref='newPassword'
				key='newPassword'
				label='New Password'
				name='newPassword'
				type='password'
				placeholder='Password'
				helpText='Minimum 6 Characters'
				manualValidate={true}
				validate={[
					{
						rule: VALIDATE_CUSTOM,
						params: (val) => {
							if (this.refs.oldPassword && this.refs.oldPassword.value() && this.refs.oldPassword.testValidity()) {
								return (val.length >= 6);
							} else {
								return !val.length;
							}
						},
					},
				]}
			/>,
		);

		return (
			<div className='account-edit'>
				<Helmet title='The FWA - Account' />
				<ConfirmDialog ref='confirm' />

				<form onSubmit={this.handleSubmit.bind(this)}>
					<ContentBlock title='Your account details'>
						{this.formElements.map((item) => item)}
					</ContentBlock>

					<SubmitBlock>
						<div className='span3 span8-mobile'>
							<InputSubmit name='Update settings' waiting={this.state.waiting} />
						</div>
						<div className='span4 account-block-submit__btw'>
							<Link to='/' onClick={this.handleDelete.bind(this)}>Delete account</Link>
						</div>
						<div className='cf'></div>
					</SubmitBlock>
				</form>

			</div>
		);
	}

	handleSubmit(e) {
		e.preventDefault();
		let fields = [];

		for (let i = 0; i < this.formElements.length; i++) {
			// get actual element refs
			fields.push(this.refs[this.formElements[i].ref]);
		}

		if (formIsValid(fields)) {
			let data = {
				name: this.refs.name.value(),
				email: this.refs.email.value(),
				receiveNewsletter: this.refs.newsletter.value,
			};

			if (this.refs.oldPassword.value() && this.refs.newPassword) {
				data.oldPassword = this.refs.oldPassword.value();
				data.newPassword = this.refs.newPassword.value();
			}

			this.props.dispatch(
				updateLogin(
					data,
					() => { //onSucces
						this.setState({...this.state, waiting: false});
					},

					() => { //onFail
						this.setState({...this.state, waiting: false});
					}
				)
			);
			this.setState({...this.state, waiting: true});
		}
	}

	handleDelete(e) {
		e.preventDefault();

		this.refs.confirm
		.confirm('Are you sure you want to delete your account?')
		.then(() => {
			this.props.dispatch(deleteLogin());
		})
		.catch(() => {});
	}
}

export default connect(AccountBasic);



/** WEBPACK FOOTER **
 ** ./frontend/components/account/basic.js
 **/